import { baseApi } from "./baseApi";

export interface ApiKey {
  id: string;
  key_prefix: string;
  name: string;
  org_id: string | null;
  roles: string[];
  created_by: string;
  expires_at: string | null;
  revoked_at: string | null;
  inserted_at: string;
  last_used_at: string | null;
}

export const meApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMyApiKeys: builder.query<ApiKey[], void>({
      query: () => "/v1/me/api-keys",
      transformResponse: (r: { api_keys: ApiKey[] }) => r.api_keys,
      providesTags: [{ type: "Users", id: "my-api-keys" }],
    }),
    createApiKey: builder.mutation<{ api_key: ApiKey; token: string }, { name: string }>({
      query: (body) => ({ url: "/v1/me/api-keys", method: "POST", body }),
      invalidatesTags: [{ type: "Users", id: "my-api-keys" }],
    }),
    revokeApiKey: builder.mutation<void, string>({
      query: (id) => ({ url: `/v1/me/api-keys/${id}`, method: "DELETE" }),
      invalidatesTags: [{ type: "Users", id: "my-api-keys" }],
    }),
    getMyPreferences: builder.query<Record<string, unknown>, void>({
      query: () => "/v1/me/preferences",
      providesTags: [{ type: "Users", id: "my-preferences" }],
    }),
    updateMyPreferences: builder.mutation<Record<string, unknown>, Record<string, unknown>>({
      query: (body) => ({ url: "/v1/me/preferences", method: "PATCH", body }),
      invalidatesTags: [{ type: "Users", id: "my-preferences" }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetMyApiKeysQuery,
  useCreateApiKeyMutation,
  useRevokeApiKeyMutation,
  useGetMyPreferencesQuery,
  useUpdateMyPreferencesMutation,
} = meApi;
